import { createAction, props } from '@ngrx/store';

import { DeviceStatus } from 'src/app/model/device-status';
import { LocalSite, Site, SiteExtTechAcl } from 'src/app/model/site';
import { User } from 'src/app/model/user';

export const getSitesData = createAction('[SiteMap] GET_SITES_DATA');
export const getSitesDataSuccess = createAction('[SiteMap] GET_SITES_DATA_SUCCESS', props<{ sites: Site[] }>());
export const getSitesDataFailed = createAction('[SiteMap] GET_SITES_DATA_FAILED', props<{ errorMessage: string }>());

export const getSiteStatusData = createAction('[SiteMap] GET_SITE_STATUS_DATA', props<{ site: Site }>());
export const getSiteStatusDataSuccess = createAction('[SiteMap] GET_SITE_STATUS_DATA_SUCCESS', props<{
    siteId: number; deviceStatus: DeviceStatus[];
}>());
export const getSiteStatusDataFailed = createAction('[SiteMap] GET_SITE_STATUS_DATA_FAILED', props<{ errorMessage: string }>());

export const getSiteOwner = createAction('[SiteMap] GET_SITE_OWNER', props<{ site: Site }>());
export const getSiteOwnerSuccess = createAction('[SiteMap] GET_SITE_OWNER_SUCCESS', props<{ siteId: number; user: User }>());
export const getSiteOwnerFailed = createAction('[SiteMap] GET_SITE_OWNER_FAILED', props<{ errorMessage: string }>());

export const getSitesExtTechAcl = createAction('[SiteMap] GET_SITES_EXT_TECHACL');
export const getSitesExtTechAclSuccess = createAction('[SiteMap] GET_SITES_EXT_TECHACL_SUCCESS', props<{ sites: SiteExtTechAcl[] }>());
export const getSitesExtTechAclFailed = createAction('[SiteMap] GET_SITES_EXT_TECHACL_FAILED', props<{ errorMessage: string }>());

export const getLocalsites = createAction('[SiteMap] GET_LOCAL_SITES');
export const getLocalsitesSuccess = createAction('[SiteMap] GET_LOCAL_SITES_SUCCESS', props<{ localsites: LocalSite[] }>());
export const getLocalsitesFailed = createAction('[SiteMap] GET_LOCAL_SITES_FAILED', props<{ errorMessage: string }>());